const COLORS_EVEN = [
  '#48C3F8',
  '#FD9D4C',
  '#30D9BB',
  '#0B7562',
  '#E1C7DC',
  '#D1D1D1',
  '#676567',
];

// const COLORS_ODD = [
//   '#a593cd',
//   '#f78f48',
//   '#79287c',
//   '#0e3151',
//   '#057ebd',
//   '#7dc242',
// ];

const colors = {
  odd: COLORS_EVEN,
  even: COLORS_EVEN,
};

export default colors;
